import styled from "styled-components";
//components
import { Button } from "components/Button";

export const Content = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;

  .text {
    width: 352px;
    font-family: Lato, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 900;
    text-align: center;
    color: #364863;

    span {
      color: red;
    }
  }

  .select {
    width: 250px;
    cursor: pointer;
  }

  .buttonContainer {
    width: 190px;
    display: flex;
    flex-direction: row;

    margin-top: 2.3em;
    justify-content: space-between;

    .cancel {
      width: 110px;
      color: #12191a;
      border: 1px solid #0e4c54;
    }
  }
`;

export const FilterButton = styled(Button)`
  background-color: #0e4c54;
  cursor: "pointer";
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  width: 110px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.disabled ? "#BEBEBE" : "#0E4C54")};
  }
`;

export const CustomIcon = styled.img`
  margin-right: 8px;
`;

export const CustomLabel = styled.p`
  color: #364863;
  font-size: 12px;
  font-weight: 400;
`;

export const CustomSpan = styled.span`
  display: flex;
  align-items: center;
`;

export const CancelButton = styled(Button)`
  font-size: 14px;
  font-weight: 700;
`;
